export const COLORS = [
    'blue',
    'green',
    'lightBlue',
    'orange',
    'red',
    'teal',
    'yellow',
    'default',
];
export const SIZES = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
export const AVATAR_ICON_SIZES = {
    xs: 16,
    sm: 24,
    md: 32,
    lg: 40,
    xl: 48,
    xxl: 64,
};
